import { createAction, createSlice } from "@reduxjs/toolkit";
import { MiDt } from "../../@types/midt";
import findDataMiDt from "./actions/findDataMiDt";
import sendDataMiDt from "./actions/sendDataMiDt";

interface fichaMiDtState {
  recordText?: string;
  ficha?: string;
  result: {
    contract?: MiDt;
    percentComplete?: any;
  };
  findStatus?: string;
  sendStatus?: string;
}

const initialState = {
  result: {},
} as fichaMiDtState;

export const setRecordText = createAction<string>("SET_RECORD_TEXT");
export const setFindStatus = createAction<string>("SET_FIND_STATUS");
export const setSendStatus = createAction<string>("SET_SEND_STATUS");
export const resetDataMiDt = createAction("RESET_DATA_MIDT");
export const setNumFicha = createAction<string>("SET_NUM_FICHA");

const fichaMiDtSlice = createSlice({
  name: "fichaMiDt",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(setRecordText, (state, { payload }) => {
        state.recordText = payload;
      })
      .addCase(setNumFicha, (state, { payload }) => {
        state.ficha = payload;
      })
      .addCase(findDataMiDt.pending, (state) => {
        state.findStatus = "pending";
      })
      .addCase(findDataMiDt.fulfilled, (state, { payload }: any) => {
        state.findStatus = "fulfilled";
        state.result = payload;
      })
      .addCase(findDataMiDt.rejected, (state) => {
        state.findStatus = "rejected";
        state.result = {}
      })
      //Send data to register midt
      .addCase(sendDataMiDt.pending, (state) => {
        state.sendStatus = "pending";
      })
      .addCase(sendDataMiDt.fulfilled, (state, { payload }: any) => {
        state.sendStatus = "fulfilled";
      })
      .addCase(sendDataMiDt.rejected, (state) => {
        state.sendStatus = "rejected";
      })
      .addCase(setFindStatus, (state, { payload }) => {
        state.findStatus = payload;
      })
      .addCase(setSendStatus, (state, { payload }) => {
        state.sendStatus = payload;
      })
      .addCase(resetDataMiDt, (state, { payload }) => {
        state.result = {};
        state.recordText = undefined;
      });
  },
});

export default fichaMiDtSlice.reducer;
